import { render, staticRenderFns } from "./ZoneList.vue?vue&type=template&id=81dddf4a&scoped=true&"
import script from "./ZoneList.vue?vue&type=script&lang=js&"
export * from "./ZoneList.vue?vue&type=script&lang=js&"
import style0 from "./ZoneList.vue?vue&type=style&index=0&id=81dddf4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81dddf4a",
  null
  
)

export default component.exports